const fields = {
    modalidade:'',
    tipo: '',
    endereco: '',
    imoveis: [],
    total: '',
    caracteristicas: [],
    caracsCondominio: [],
    tipos:[
        {
            'name': 'Selecione',
            'value': 0
        }
    ],
    bairros: [],
    cidades: [],
    order:'',
    limit: 12,
    offset: 0,
    page: 1,
    filtros: {
        'valorInicial':'',
        'valorFinal':'',
        'areaInicial':'',
        'areaFinal':'',        
        'quartos':'',
        'suites':'',
        'banheiros':'',
        'vagas':''        
    },
    caracSelecionados:[],
    caracSelecionadosCondominio: []
};

export default fields;
